export interface Condition {
  ConditionID: string;
  OptedOut: boolean;
  Data: string;
}
export interface VenueContact {
  PrivatePIN: string;
  VenueContactID: string;
  VenueID: string;
  VenueSystemRoles: number;
}
export interface AuthenticatedUserInterface {
  BirthDate: string;
  Conditions: Condition[];
  EmailAddress: string;
  ExternalID: string;
  FirstName: string;
  ID: string;
  IsFemale: boolean;
  LastName: string;
  Status: number;
  SystemRoles: number;
  VenueContacts: VenueContact[];
}
export interface ClubSparkTokenAuthInterface {
  token: string;
}
export interface ClubSparkAuthenticationInterface {
  user: AuthenticatedUserInterface;
  metadata?: ClubSparkTokenAuthInterface;
}

export enum SafePlayStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Expired = 'EXPIRED',
  NotStarted = 'NOTSTARTED',
  NotApproved = 'NOTAPPROVED',
  NotSet = 'NOTSET',
}
